"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SvgIcon = require("../icons/SvgIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var DeleteRowButton = function DeleteRowButton(_ref) {
  var deleteInProgress = _ref.deleteInProgress,
    id = _ref.id,
    name = _ref.name,
    _onClick = _ref.onClick,
    title = _ref.title;
  if (deleteInProgress) {
    var deletingMsgStyle = {
      position: "relative",
      left: "-12px",
      padding: "4px",
      width: "60px",
      backgroundColor: "#7c0417",
      color: "#fff",
      fontSize: "14px"
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: deletingMsgStyle
    }, "Deleting");
  }
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon.IconButton, {
    iconName: _SvgIcon.ICON_NAME.Trash,
    onClick: function onClick() {
      return _onClick(id, name);
    },
    title: title
  });
};
var _default = DeleteRowButton;
exports["default"] = _default;
DeleteRowButton.propTypes = {
  status: _propTypes["default"].string,
  title: _propTypes["default"].string,
  deleteInProgress: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired
};